import { __decorate, __metadata } from "tslib";
import { SerializableObject, SerializableMember, DataObject, SerializableArrayMember, Matrix3 } from '@openhps/core';
/**
 * Camera source object
 */
let CameraObject = class CameraObject extends DataObject {
    /**
     * Get the focal length in pixels
     * @returns {[number, number]} Focal length for x and y axis
     */
    get focalLength() {
        if (!this.cameraMatrix) {
            return undefined;
        }
        return [this.cameraMatrix.elements[0], this.cameraMatrix.elements[4]];
    }
    /**
     * Get the principal point in pixels
     * @returns {[number, number]} Principal point for x and y axis
     */
    get principalPoint() {
        if (!this.cameraMatrix) {
            return undefined;
        }
        return [this.cameraMatrix.elements[6], this.cameraMatrix.elements[7]];
    }
    /**
     * Camera frustum aspect ratio.
     * @returns {number} Aspect ratio
     */
    get aspect() {
        return this.width / this.height;
    }
    /**
     * Height of image
     * @returns {number} Height
     */
    get rows() {
        return this.height;
    }
    set rows(value) {
        this.height = value;
    }
    /**
     * Width of image
     * @returns {number} Width
     */
    get cols() {
        return this.width;
    }
    set cols(value) {
        this.width = value;
    }
    constructor(uid, displayName, width, height) {
        var _a;
        super(uid, displayName);
        /**
         * Camera color order
         */
        this.colorOrder = ColorOrder.RGB;
        this.width = width || 0;
        this.height = height || 0;
        this.distortionCoefficients = (_a = this.distortionCoefficients) !== null && _a !== void 0 ? _a : [0, 0, 0, 0, 0];
    }
};
__decorate([
    SerializableMember(),
    __metadata("design:type", Number)
], CameraObject.prototype, "width", void 0);
__decorate([
    SerializableMember(),
    __metadata("design:type", Number)
], CameraObject.prototype, "height", void 0);
__decorate([
    SerializableArrayMember(Number),
    __metadata("design:type", Array)
], CameraObject.prototype, "distortionCoefficients", void 0);
__decorate([
    SerializableMember(),
    __metadata("design:type", Matrix3)
], CameraObject.prototype, "cameraMatrix", void 0);
__decorate([
    SerializableMember(),
    __metadata("design:type", Number)
], CameraObject.prototype, "fps", void 0);
__decorate([
    SerializableMember(),
    __metadata("design:type", Number)
], CameraObject.prototype, "colorOrder", void 0);
CameraObject = __decorate([
    SerializableObject(),
    __metadata("design:paramtypes", [String, String, Number, Number])
], CameraObject);
export { CameraObject };
/**
 * Color order
 */
export var ColorOrder;
(function (ColorOrder) {
    ColorOrder[ColorOrder["RGB"] = 0] = "RGB";
    ColorOrder[ColorOrder["BGR"] = 1] = "BGR";
    ColorOrder[ColorOrder["GRAYSCALE"] = 2] = "GRAYSCALE";
    ColorOrder[ColorOrder["RGBA"] = 3] = "RGBA";
    ColorOrder[ColorOrder["BGRA"] = 4] = "BGRA";
})(ColorOrder || (ColorOrder = {}));
//# sourceMappingURL=CameraObject.js.map